import { gql, useQuery } from "@apollo/client";
import CircleIcon from "@mui/icons-material/Circle";
import SyncIcon from "@mui/icons-material/Sync";
import { Button } from "@mui/material";
import { format } from "date-fns";
import { ReactElement, useContext } from "react";

import { Collection } from "../../../../generated/gql/graphql";
import { CollectionAssetsContext } from "../../../../providers/collection-assets-provider";
import ContextMenu from "../context-menu/context-menu";
import { getSyncStatusColor } from "../sync-logs/sync-log-utils";

const GET_LATEST_SYNC_LOGS = gql`
  query GetLatestCollectionSyncLog($getLatestCollectionSyncLogId: String!) {
    getLatestCollectionSyncLog(id: $getLatestCollectionSyncLogId) {
      item {
        status
        id
        assetIds
        dateCreated
      }
    }
  }
`;

type Props = {
  title: string;
  amount?: number;
  collection?: Collection;
  onSync?: (v: boolean) => void;
};

export default function Header(props: Props): ReactElement {
  const { title, collection, amount, onSync } = props;

  const { totalCount } = useContext(CollectionAssetsContext);

  const { data: latestSyncLogsData } = useQuery(GET_LATEST_SYNC_LOGS, {
    variables: {
      getLatestCollectionSyncLogId: collection?.id,
    },
  });
  const latestSyncLogs = latestSyncLogsData?.getLatestCollectionSyncLog?.item;

  return (
    <div className="flex w-full justify-items-center h-fit justify-between">
      <div>
        <div className="flex">
          <h2 className="text-[24px] text-rose-600">
            {title}
            <span className="text-[16px] text-slate-400">
              {" "}
              ({amount || totalCount})
            </span>
          </h2>
          {collection && (
            <ContextMenu
              imageId="1"
              classes="bg-white rounded-[25px] right-[17px] top-[17px]"
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              collection={collection}
            />
          )}
        </div>
        {latestSyncLogs && (
          <div>
            <span>This collection is Synching with </span>
            {collection?.externalServiceConnections?.join(", ")}
          </div>
        )}
      </div>
      {collection && (
        <div className="flex gap-10">
          {latestSyncLogs && (
            <>
              <CircleIcon
                className={getSyncStatusColor(latestSyncLogs.status)}
              />
              <div className="text-[12px] text-[#4A4A4A]">
                Collection is synced
                <span className="block text-[#999999]">
                  Last synced{" "}
                  {format(new Date(latestSyncLogs.dateCreated), "dd/MM/yyyy")}
                </span>
              </div>
            </>
          )}
          {collection.externalServiceConnections &&
            collection?.externalServiceConnections.length > 0 && (
              <Button
                onClick={() => onSync?.(true)}
                className="capitalize whitespace-nowrap rounded-full border-2 hover:border-2 h-fit"
                variant="outlined"
                startIcon={<SyncIcon />}
                disableRipple
              >
                Sync collection
              </Button>
            )}
        </div>
      )}
    </div>
  );
}
